// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FamilyHistoryPopup-module__font-s-10___LIwtD {
  font-size: 10px !important;
}

.FamilyHistoryPopup-module__font-s-12___MjnSw {
  font-size: 12px !important;
}

.FamilyHistoryPopup-module__font-s-13___OoLfJ {
  font-size: 13px !important;
}

.FamilyHistoryPopup-module__font-s-14___Efg1R {
  font-size: 14px !important;
}

.FamilyHistoryPopup-module__font-s-15___hAvca {
  font-size: 15px !important;
}

.FamilyHistoryPopup-module__font-s-16___GWRtI {
  font-size: 16px !important;
}

.FamilyHistoryPopup-module__font-s-18___yqJsx {
  font-size: 18px !important;
}

.FamilyHistoryPopup-module__font-s-20___Bvr2p {
  font-size: 20px !important;
}

.FamilyHistoryPopup-module__font-s-22____TINk {
  font-size: 22px !important;
}

.FamilyHistoryPopup-module__font-s-28___oSAZL {
  font-size: 28px !important;
}

.FamilyHistoryPopup-module__font-w-400___crF2Z {
  font-weight: 400 !important;
}

.FamilyHistoryPopup-module__font-w-500___avm44 {
  font-weight: 500 !important;
}

.FamilyHistoryPopup-module__font-w-600___Pwljk {
  font-weight: 600 !important;
}

.FamilyHistoryPopup-module__font-w-700___EqstE {
  font-weight: 700 !important;
}

.FamilyHistoryPopup-module__p-5___Veyk6 {
  padding: 5px !important;
}

.FamilyHistoryPopup-module__p-12___w95V3 {
  padding: 12px !important;
}

.FamilyHistoryPopup-module__p-16___QTPnO {
  padding: 16px !important;
}

.FamilyHistoryPopup-module__p-30___Xos6U {
  padding: 30px !important;
}

.FamilyHistoryPopup-module__p-b-0___kn1YY {
  padding-bottom: 0 !important;
}

.FamilyHistoryPopup-module__p-b-5___e_Eis {
  padding-bottom: 5px !important;
}

.FamilyHistoryPopup-module__p-b-10___XO3mt {
  padding-bottom: 10px !important;
}

.FamilyHistoryPopup-module__p-b-12___ygEs6 {
  padding-bottom: 12px !important;
}

.FamilyHistoryPopup-module__p-b-16___gBCnC {
  padding-bottom: 16px !important;
}

.FamilyHistoryPopup-module__p-b-18___kx3vA {
  padding-bottom: 18px !important;
}

.FamilyHistoryPopup-module__p-b-20___bo9dW {
  padding-bottom: 20px !important;
}

.FamilyHistoryPopup-module__p-b-25___ECIi3 {
  padding-bottom: 25px !important;
}

.FamilyHistoryPopup-module__p-b-30___oFUeV {
  padding-bottom: 30px !important;
}

.FamilyHistoryPopup-module__p-b-50___pVL0k {
  padding-bottom: 50px !important;
}

.FamilyHistoryPopup-module__p-t-0___Cc6rG {
  padding-top: 0 !important;
}

.FamilyHistoryPopup-module__p-t-12___eLg9v {
  padding-top: 12px !important;
}

.FamilyHistoryPopup-module__p-t-16___iPf_h {
  padding-top: 16px !important;
}

.FamilyHistoryPopup-module__p-t-18___E7r_b {
  padding-top: 18px !important;
}

.FamilyHistoryPopup-module__p-t-20___nHZpC {
  padding-top: 20px !important;
}

.FamilyHistoryPopup-module__p-t-30___mCRpr {
  padding-top: 30px !important;
}

.FamilyHistoryPopup-module__p-t-40___r70ja {
  padding-top: 40px !important;
}

.FamilyHistoryPopup-module__p-t-50___YY10o {
  padding-top: 50px !important;
}

.FamilyHistoryPopup-module__p-l-20___qpiUF {
  padding-left: 20px !important;
}

.FamilyHistoryPopup-module__p-l-30___ex_mc {
  padding-left: 30px !important;
}

.FamilyHistoryPopup-module__p-l-40___X5Hdu {
  padding-left: 40px !important;
}

.FamilyHistoryPopup-module__p-r-16___HPjBj {
  padding-right: 16px !important;
}

.FamilyHistoryPopup-module__p-r-20___X91AT {
  padding-right: 20px !important;
}

.FamilyHistoryPopup-module__p-r-30___rrbnu {
  padding-right: 30px !important;
}

.FamilyHistoryPopup-module__p-r-50___za3N8 {
  padding-right: 50px !important;
}

.FamilyHistoryPopup-module__p-r-60___ioMj6 {
  padding-right: 60px !important;
}

.FamilyHistoryPopup-module__m-b-1____J7ja {
  margin-bottom: 1px !important;
}

.FamilyHistoryPopup-module__m-b-2___k1rbK {
  margin-bottom: 2px !important;
}

.FamilyHistoryPopup-module__m-b-6___zhMSL {
  margin-bottom: 6px !important;
}

.FamilyHistoryPopup-module__m-b-8___gBHr1 {
  margin-bottom: 8px !important;
}

.FamilyHistoryPopup-module__m-b-10___RU917 {
  margin-bottom: 10px !important;
}

.FamilyHistoryPopup-module__m-b-14___rSmEw {
  margin-bottom: 14px !important;
}

.FamilyHistoryPopup-module__m-b-16___fcCOv {
  margin-bottom: 16px !important;
}

.FamilyHistoryPopup-module__m-b-20___WXKqZ {
  margin-bottom: 20px !important;
}

.FamilyHistoryPopup-module__m-b-22___ccvzi {
  margin-bottom: 22px !important;
}

.FamilyHistoryPopup-module__m-b-24___ykl65 {
  margin-bottom: 24px !important;
}

.FamilyHistoryPopup-module__m-b-30___yYqT8 {
  margin-bottom: 30px !important;
}

.FamilyHistoryPopup-module__m-b-32___lWJB5 {
  margin-bottom: 32px !important;
}

.FamilyHistoryPopup-module__m-b-40___Nytbr {
  margin-bottom: 40px !important;
}

.FamilyHistoryPopup-module__m-t-2___elPeb {
  margin-top: 2px !important;
}

.FamilyHistoryPopup-module__m-t-3___ASJyC {
  margin-top: 3px !important;
}

.FamilyHistoryPopup-module__m-t-4___Z0f5v {
  margin-top: 4px !important;
}

.FamilyHistoryPopup-module__m-t-5___tKu_f {
  margin-top: 5px !important;
}

.FamilyHistoryPopup-module__m-t-8___LBzrs {
  margin-top: 8px !important;
}

.FamilyHistoryPopup-module__m-t-10___aZ0Uo {
  margin-top: 10px !important;
}

.FamilyHistoryPopup-module__m-t-15___atOE4 {
  margin-top: 15px !important;
}

.FamilyHistoryPopup-module__m-t-16___dy61t {
  margin-top: 16px !important;
}

.FamilyHistoryPopup-module__m-t-20___c22Ai {
  margin-top: 20px !important;
}

.FamilyHistoryPopup-module__m-t-22___lZun3 {
  margin-top: 22px !important;
}

.FamilyHistoryPopup-module__m-t-30___vfRYe {
  margin-top: 30px !important;
}

.FamilyHistoryPopup-module__m-t-32___Xf2BD {
  margin-top: 32px !important;
}

.FamilyHistoryPopup-module__m-l-auto___TeJqc {
  margin-left: auto !important;
}

.FamilyHistoryPopup-module__m-l-4___NxxN7 {
  margin-left: 4px !important;
}

.FamilyHistoryPopup-module__m-l-5___K3kBe {
  margin-left: 5px !important;
}

.FamilyHistoryPopup-module__m-l-6___VgM4f {
  margin-left: 6px !important;
}

.FamilyHistoryPopup-module__m-l-8___DbNrC {
  margin-left: 8px !important;
}

.FamilyHistoryPopup-module__m-l-10___toS7j {
  margin-left: 10px !important;
}

.FamilyHistoryPopup-module__m-l-16___FiL5u {
  margin-left: 16px !important;
}

.FamilyHistoryPopup-module__m-l-20___lRtkU {
  margin-left: 20px !important;
}

.FamilyHistoryPopup-module__m-l-24___f8Bip {
  margin-left: 24px !important;
}

.FamilyHistoryPopup-module__m-l-30___rb4fb {
  margin-left: 30px !important;
}

.FamilyHistoryPopup-module__m-l-35___aqH5u {
  margin-left: 35px !important;
}

.FamilyHistoryPopup-module__m-l-40___FrFn2 {
  margin-left: 40px !important;
}

.FamilyHistoryPopup-module__m-r-8___XbK6c {
  margin-right: 8px !important;
}

.FamilyHistoryPopup-module__m-r-10___sMYeZ {
  margin-right: 10px !important;
}

.FamilyHistoryPopup-module__m-r-16___jHbgN {
  margin-right: 16px !important;
}

.FamilyHistoryPopup-module__m-r-20___f2ExY {
  margin-right: 20px !important;
}

.FamilyHistoryPopup-module__m-r-24___gJorA {
  margin-right: 24px !important;
}

.FamilyHistoryPopup-module__m-r-30___JBdJi {
  margin-right: 30px !important;
}

.FamilyHistoryPopup-module__m-r-40___D1Cuv {
  margin-right: 40px !important;
}

.FamilyHistoryPopup-module__border-r-3___GXAMR {
  border-radius: 3px !important;
}

.FamilyHistoryPopup-module__border-r-4___S6pJe {
  border-radius: 4px !important;
}

.FamilyHistoryPopup-module__border-r-6___hlxLT {
  border-radius: 6px !important;
}

.FamilyHistoryPopup-module__border-r-10___fjIPg {
  border-radius: 10px !important;
}

.FamilyHistoryPopup-module__border-r-12___pXCqa {
  border-radius: 12px !important;
}

.FamilyHistoryPopup-module__border-r-16___E1OxA {
  border-radius: 16px !important;
}

.FamilyHistoryPopup-module__border-r-50___JWGQ4 {
  border-radius: 50% !important;
}

.FamilyHistoryPopup-module__primary-border___NctAA {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.FamilyHistoryPopup-module__primary-border-b___mnmBH {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.FamilyHistoryPopup-module__primary-border-t___Sk7zt {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.FamilyHistoryPopup-module__primary-border-l___dTZV5 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.FamilyHistoryPopup-module__primary-border-r___joZzV {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.FamilyHistoryPopup-module__secondary-border___hubhc {
  border: 1px solid #637768;
}

.FamilyHistoryPopup-module__secondary-border-b___xwEtJ {
  border-bottom: 1px solid #637768;
}

.FamilyHistoryPopup-module__secondary-border-t___fQnTQ {
  border-top: 1px solid #637768;
}

.FamilyHistoryPopup-module__secondary-border-l___mtidH {
  border-left: 1px solid #637768;
}

.FamilyHistoryPopup-module__secondary-border-r___FAIo4 {
  border-right: 1px solid #637768;
}

.FamilyHistoryPopup-module__gap-0___wWhV2 {
  gap: 0 !important;
}

.FamilyHistoryPopup-module__gap-2___qSbdP {
  gap: 2px !important;
}

.FamilyHistoryPopup-module__gap-4___hYqBB {
  gap: 4px !important;
}

.FamilyHistoryPopup-module__gap-5___DTQ_V {
  gap: 5px !important;
}

.FamilyHistoryPopup-module__gap-6___o1om8 {
  gap: 6px !important;
}

.FamilyHistoryPopup-module__gap-8___tCPeR {
  gap: 8px !important;
}

.FamilyHistoryPopup-module__gap-10____mBWn {
  gap: 10px !important;
}

.FamilyHistoryPopup-module__gap-12___fnR_F {
  gap: 12px !important;
}

.FamilyHistoryPopup-module__gap-14___Qsa9t {
  gap: 14px !important;
}

.FamilyHistoryPopup-module__gap-16___GOVh2 {
  gap: 16px !important;
}

.FamilyHistoryPopup-module__gap-18___wkJJE {
  gap: 18px !important;
}

.FamilyHistoryPopup-module__gap-20___AnIIh {
  gap: 20px !important;
}

.FamilyHistoryPopup-module__gap-24___We6fn {
  gap: 24px !important;
}

.FamilyHistoryPopup-module__gap-26___WSYIN {
  gap: 26px !important;
}

.FamilyHistoryPopup-module__gap-30___CULQN {
  gap: 30px !important;
}

.FamilyHistoryPopup-module__gap-32___ZMdCf {
  gap: 32px !important;
}

.FamilyHistoryPopup-module__gap-40___mdQH_ {
  gap: 40px !important;
}

.FamilyHistoryPopup-module__gap-50___xZdk1 {
  gap: 50px !important;
}

.FamilyHistoryPopup-module__flex-1___srK45 {
  flex: 1;
}

.FamilyHistoryPopup-module__flex-none___OU6Va {
  flex: none !important;
}

.FamilyHistoryPopup-module__flex-column___i5Szr {
  display: flex;
  flex-direction: column !important;
}

.FamilyHistoryPopup-module__flex-row___D5Wqm {
  display: flex;
  flex-direction: row !important;
}

.FamilyHistoryPopup-module__vertically-centered___xg6I3 {
  display: flex;
  align-items: center !important;
}

.FamilyHistoryPopup-module__horizontally-centered___WEJGB {
  display: flex;
  justify-content: center !important;
}

.FamilyHistoryPopup-module__horizontally-end___ru8Qi {
  display: flex;
  justify-content: end !important;
}

.FamilyHistoryPopup-module__vertically-start___XoIzQ {
  display: flex;
  align-items: start !important;
}

.FamilyHistoryPopup-module__space-between___swE9M {
  display: flex;
  justify-content: space-between !important;
}

.FamilyHistoryPopup-module__flex-wrap___uY2Et {
  flex-wrap: wrap !important;
}

.FamilyHistoryPopup-module__height-100___cNOSW {
  height: 100%;
}

.FamilyHistoryPopup-module__width-50___qC9sS {
  width: 50% !important;
}

.FamilyHistoryPopup-module__width-100___n9rK9 {
  width: 100%;
}

.FamilyHistoryPopup-module__cursor-pointer___Ljpwj {
  cursor: pointer;
}

.FamilyHistoryPopup-module__cursor-not-allowed___OuJA1 {
  cursor: not-allowed !important;
}

.FamilyHistoryPopup-module__absolute-centered___Kd59i {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.FamilyHistoryPopup-module__absolute___W9aXN {
  position: absolute;
}

.FamilyHistoryPopup-module__relative___zVvXa {
  position: relative;
}

.FamilyHistoryPopup-module__fixed___dXzgu {
  position: fixed;
}

.FamilyHistoryPopup-module__visible___PpDHc {
  opacity: 1;
}

.FamilyHistoryPopup-module__invisible___dgrWi {
  opacity: 0;
}

.FamilyHistoryPopup-module__col-90___gdJM7 {
  width: 90% !important;
}

.FamilyHistoryPopup-module__col-auto___nVTtM {
  width: auto !important;
}

.FamilyHistoryPopup-module__medical-tabs___Dn71N {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.FamilyHistoryPopup-module__medical-table-new___vmSQc {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FamilyHistoryPopup-module__medical-table-new___vmSQc:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FamilyHistoryPopup-module__medical-table-new___vmSQc::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FamilyHistoryPopup-module__medical-table-new___vmSQc::-webkit-scrollbar-track {
  display: none;
}
.FamilyHistoryPopup-module__medical-table-new___vmSQc.FamilyHistoryPopup-module__no-pagination___cO1VX {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FamilyHistoryPopup-module__medical-table-new___vmSQc.FamilyHistoryPopup-module__no-pagination___cO1VX:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FamilyHistoryPopup-module__medical-table-new___vmSQc.FamilyHistoryPopup-module__no-pagination___cO1VX::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FamilyHistoryPopup-module__medical-table-new___vmSQc.FamilyHistoryPopup-module__no-pagination___cO1VX::-webkit-scrollbar-track {
  display: none;
}

.FamilyHistoryPopup-module__medical-table-empty___WgSS7 {
  padding: 14px 40px !important;
}

.FamilyHistoryPopup-module__icon-btn___WdThb {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.FamilyHistoryPopup-module__search-icon___bK7N4 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.FamilyHistoryPopup-module__disable-select___nOjH1 {
  user-select: none;
}

.FamilyHistoryPopup-module__break-word___X0JJb {
  word-break: break-word;
}

.FamilyHistoryPopup-module__popup-clear-btn___qB3Z6 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.FamilyHistoryPopup-module__scroll-m-b-20___DuztA {
  scroll-margin-bottom: 20px;
}

.FamilyHistoryPopup-module__grid___v238h {
  display: grid;
  padding: 25px 30px;
  grid-row-gap: 25px;
  align-items: center;
  grid-column-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
}
.FamilyHistoryPopup-module__grid___v238h .FamilyHistoryPopup-module__width100___ZTTCp {
  grid-column: 3 span;
}

.FamilyHistoryPopup-module__buttonsContainer___W0k48 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
  justify-content: end;
  padding: 30px;
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/FamilyHistoryPopup/FamilyHistoryPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qCAAA;AA8pBF;AA5pBE;EACE,mBAAA;AA8pBJ;;AA1pBA;EACE,2CAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AA6pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.grid {\n  display: grid;\n  padding: 25px 30px;\n  grid-row-gap: 25px;\n  align-items: center;\n  grid-column-gap: 25px;\n  grid-template-columns: repeat(3, 1fr);\n\n  .width100 {\n    grid-column: 3 span;\n  }\n}\n\n.buttonsContainer {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n  justify-content: end;\n  padding: 30px;\n  display: flex;\n  gap: 16px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `FamilyHistoryPopup-module__font-s-10___LIwtD`,
	"fontS12": `FamilyHistoryPopup-module__font-s-12___MjnSw`,
	"fontS13": `FamilyHistoryPopup-module__font-s-13___OoLfJ`,
	"fontS14": `FamilyHistoryPopup-module__font-s-14___Efg1R`,
	"fontS15": `FamilyHistoryPopup-module__font-s-15___hAvca`,
	"fontS16": `FamilyHistoryPopup-module__font-s-16___GWRtI`,
	"fontS18": `FamilyHistoryPopup-module__font-s-18___yqJsx`,
	"fontS20": `FamilyHistoryPopup-module__font-s-20___Bvr2p`,
	"fontS22": `FamilyHistoryPopup-module__font-s-22____TINk`,
	"fontS28": `FamilyHistoryPopup-module__font-s-28___oSAZL`,
	"fontW400": `FamilyHistoryPopup-module__font-w-400___crF2Z`,
	"fontW500": `FamilyHistoryPopup-module__font-w-500___avm44`,
	"fontW600": `FamilyHistoryPopup-module__font-w-600___Pwljk`,
	"fontW700": `FamilyHistoryPopup-module__font-w-700___EqstE`,
	"p5": `FamilyHistoryPopup-module__p-5___Veyk6`,
	"p12": `FamilyHistoryPopup-module__p-12___w95V3`,
	"p16": `FamilyHistoryPopup-module__p-16___QTPnO`,
	"p30": `FamilyHistoryPopup-module__p-30___Xos6U`,
	"pB0": `FamilyHistoryPopup-module__p-b-0___kn1YY`,
	"pB5": `FamilyHistoryPopup-module__p-b-5___e_Eis`,
	"pB10": `FamilyHistoryPopup-module__p-b-10___XO3mt`,
	"pB12": `FamilyHistoryPopup-module__p-b-12___ygEs6`,
	"pB16": `FamilyHistoryPopup-module__p-b-16___gBCnC`,
	"pB18": `FamilyHistoryPopup-module__p-b-18___kx3vA`,
	"pB20": `FamilyHistoryPopup-module__p-b-20___bo9dW`,
	"pB25": `FamilyHistoryPopup-module__p-b-25___ECIi3`,
	"pB30": `FamilyHistoryPopup-module__p-b-30___oFUeV`,
	"pB50": `FamilyHistoryPopup-module__p-b-50___pVL0k`,
	"pT0": `FamilyHistoryPopup-module__p-t-0___Cc6rG`,
	"pT12": `FamilyHistoryPopup-module__p-t-12___eLg9v`,
	"pT16": `FamilyHistoryPopup-module__p-t-16___iPf_h`,
	"pT18": `FamilyHistoryPopup-module__p-t-18___E7r_b`,
	"pT20": `FamilyHistoryPopup-module__p-t-20___nHZpC`,
	"pT30": `FamilyHistoryPopup-module__p-t-30___mCRpr`,
	"pT40": `FamilyHistoryPopup-module__p-t-40___r70ja`,
	"pT50": `FamilyHistoryPopup-module__p-t-50___YY10o`,
	"pL20": `FamilyHistoryPopup-module__p-l-20___qpiUF`,
	"pL30": `FamilyHistoryPopup-module__p-l-30___ex_mc`,
	"pL40": `FamilyHistoryPopup-module__p-l-40___X5Hdu`,
	"pR16": `FamilyHistoryPopup-module__p-r-16___HPjBj`,
	"pR20": `FamilyHistoryPopup-module__p-r-20___X91AT`,
	"pR30": `FamilyHistoryPopup-module__p-r-30___rrbnu`,
	"pR50": `FamilyHistoryPopup-module__p-r-50___za3N8`,
	"pR60": `FamilyHistoryPopup-module__p-r-60___ioMj6`,
	"mB1": `FamilyHistoryPopup-module__m-b-1____J7ja`,
	"mB2": `FamilyHistoryPopup-module__m-b-2___k1rbK`,
	"mB6": `FamilyHistoryPopup-module__m-b-6___zhMSL`,
	"mB8": `FamilyHistoryPopup-module__m-b-8___gBHr1`,
	"mB10": `FamilyHistoryPopup-module__m-b-10___RU917`,
	"mB14": `FamilyHistoryPopup-module__m-b-14___rSmEw`,
	"mB16": `FamilyHistoryPopup-module__m-b-16___fcCOv`,
	"mB20": `FamilyHistoryPopup-module__m-b-20___WXKqZ`,
	"mB22": `FamilyHistoryPopup-module__m-b-22___ccvzi`,
	"mB24": `FamilyHistoryPopup-module__m-b-24___ykl65`,
	"mB30": `FamilyHistoryPopup-module__m-b-30___yYqT8`,
	"mB32": `FamilyHistoryPopup-module__m-b-32___lWJB5`,
	"mB40": `FamilyHistoryPopup-module__m-b-40___Nytbr`,
	"mT2": `FamilyHistoryPopup-module__m-t-2___elPeb`,
	"mT3": `FamilyHistoryPopup-module__m-t-3___ASJyC`,
	"mT4": `FamilyHistoryPopup-module__m-t-4___Z0f5v`,
	"mT5": `FamilyHistoryPopup-module__m-t-5___tKu_f`,
	"mT8": `FamilyHistoryPopup-module__m-t-8___LBzrs`,
	"mT10": `FamilyHistoryPopup-module__m-t-10___aZ0Uo`,
	"mT15": `FamilyHistoryPopup-module__m-t-15___atOE4`,
	"mT16": `FamilyHistoryPopup-module__m-t-16___dy61t`,
	"mT20": `FamilyHistoryPopup-module__m-t-20___c22Ai`,
	"mT22": `FamilyHistoryPopup-module__m-t-22___lZun3`,
	"mT30": `FamilyHistoryPopup-module__m-t-30___vfRYe`,
	"mT32": `FamilyHistoryPopup-module__m-t-32___Xf2BD`,
	"mLAuto": `FamilyHistoryPopup-module__m-l-auto___TeJqc`,
	"mL4": `FamilyHistoryPopup-module__m-l-4___NxxN7`,
	"mL5": `FamilyHistoryPopup-module__m-l-5___K3kBe`,
	"mL6": `FamilyHistoryPopup-module__m-l-6___VgM4f`,
	"mL8": `FamilyHistoryPopup-module__m-l-8___DbNrC`,
	"mL10": `FamilyHistoryPopup-module__m-l-10___toS7j`,
	"mL16": `FamilyHistoryPopup-module__m-l-16___FiL5u`,
	"mL20": `FamilyHistoryPopup-module__m-l-20___lRtkU`,
	"mL24": `FamilyHistoryPopup-module__m-l-24___f8Bip`,
	"mL30": `FamilyHistoryPopup-module__m-l-30___rb4fb`,
	"mL35": `FamilyHistoryPopup-module__m-l-35___aqH5u`,
	"mL40": `FamilyHistoryPopup-module__m-l-40___FrFn2`,
	"mR8": `FamilyHistoryPopup-module__m-r-8___XbK6c`,
	"mR10": `FamilyHistoryPopup-module__m-r-10___sMYeZ`,
	"mR16": `FamilyHistoryPopup-module__m-r-16___jHbgN`,
	"mR20": `FamilyHistoryPopup-module__m-r-20___f2ExY`,
	"mR24": `FamilyHistoryPopup-module__m-r-24___gJorA`,
	"mR30": `FamilyHistoryPopup-module__m-r-30___JBdJi`,
	"mR40": `FamilyHistoryPopup-module__m-r-40___D1Cuv`,
	"borderR3": `FamilyHistoryPopup-module__border-r-3___GXAMR`,
	"borderR4": `FamilyHistoryPopup-module__border-r-4___S6pJe`,
	"borderR6": `FamilyHistoryPopup-module__border-r-6___hlxLT`,
	"borderR10": `FamilyHistoryPopup-module__border-r-10___fjIPg`,
	"borderR12": `FamilyHistoryPopup-module__border-r-12___pXCqa`,
	"borderR16": `FamilyHistoryPopup-module__border-r-16___E1OxA`,
	"borderR50": `FamilyHistoryPopup-module__border-r-50___JWGQ4`,
	"primaryBorder": `FamilyHistoryPopup-module__primary-border___NctAA`,
	"primaryBorderB": `FamilyHistoryPopup-module__primary-border-b___mnmBH`,
	"primaryBorderT": `FamilyHistoryPopup-module__primary-border-t___Sk7zt`,
	"primaryBorderL": `FamilyHistoryPopup-module__primary-border-l___dTZV5`,
	"primaryBorderR": `FamilyHistoryPopup-module__primary-border-r___joZzV`,
	"secondaryBorder": `FamilyHistoryPopup-module__secondary-border___hubhc`,
	"secondaryBorderB": `FamilyHistoryPopup-module__secondary-border-b___xwEtJ`,
	"secondaryBorderT": `FamilyHistoryPopup-module__secondary-border-t___fQnTQ`,
	"secondaryBorderL": `FamilyHistoryPopup-module__secondary-border-l___mtidH`,
	"secondaryBorderR": `FamilyHistoryPopup-module__secondary-border-r___FAIo4`,
	"gap0": `FamilyHistoryPopup-module__gap-0___wWhV2`,
	"gap2": `FamilyHistoryPopup-module__gap-2___qSbdP`,
	"gap4": `FamilyHistoryPopup-module__gap-4___hYqBB`,
	"gap5": `FamilyHistoryPopup-module__gap-5___DTQ_V`,
	"gap6": `FamilyHistoryPopup-module__gap-6___o1om8`,
	"gap8": `FamilyHistoryPopup-module__gap-8___tCPeR`,
	"gap10": `FamilyHistoryPopup-module__gap-10____mBWn`,
	"gap12": `FamilyHistoryPopup-module__gap-12___fnR_F`,
	"gap14": `FamilyHistoryPopup-module__gap-14___Qsa9t`,
	"gap16": `FamilyHistoryPopup-module__gap-16___GOVh2`,
	"gap18": `FamilyHistoryPopup-module__gap-18___wkJJE`,
	"gap20": `FamilyHistoryPopup-module__gap-20___AnIIh`,
	"gap24": `FamilyHistoryPopup-module__gap-24___We6fn`,
	"gap26": `FamilyHistoryPopup-module__gap-26___WSYIN`,
	"gap30": `FamilyHistoryPopup-module__gap-30___CULQN`,
	"gap32": `FamilyHistoryPopup-module__gap-32___ZMdCf`,
	"gap40": `FamilyHistoryPopup-module__gap-40___mdQH_`,
	"gap50": `FamilyHistoryPopup-module__gap-50___xZdk1`,
	"flex1": `FamilyHistoryPopup-module__flex-1___srK45`,
	"flexNone": `FamilyHistoryPopup-module__flex-none___OU6Va`,
	"flexColumn": `FamilyHistoryPopup-module__flex-column___i5Szr`,
	"flexRow": `FamilyHistoryPopup-module__flex-row___D5Wqm`,
	"verticallyCentered": `FamilyHistoryPopup-module__vertically-centered___xg6I3`,
	"horizontallyCentered": `FamilyHistoryPopup-module__horizontally-centered___WEJGB`,
	"horizontallyEnd": `FamilyHistoryPopup-module__horizontally-end___ru8Qi`,
	"verticallyStart": `FamilyHistoryPopup-module__vertically-start___XoIzQ`,
	"spaceBetween": `FamilyHistoryPopup-module__space-between___swE9M`,
	"flexWrap": `FamilyHistoryPopup-module__flex-wrap___uY2Et`,
	"height100": `FamilyHistoryPopup-module__height-100___cNOSW`,
	"width50": `FamilyHistoryPopup-module__width-50___qC9sS`,
	"width100": `FamilyHistoryPopup-module__width-100___n9rK9`,
	"cursorPointer": `FamilyHistoryPopup-module__cursor-pointer___Ljpwj`,
	"cursorNotAllowed": `FamilyHistoryPopup-module__cursor-not-allowed___OuJA1`,
	"absoluteCentered": `FamilyHistoryPopup-module__absolute-centered___Kd59i`,
	"absolute": `FamilyHistoryPopup-module__absolute___W9aXN`,
	"relative": `FamilyHistoryPopup-module__relative___zVvXa`,
	"fixed": `FamilyHistoryPopup-module__fixed___dXzgu`,
	"visible": `FamilyHistoryPopup-module__visible___PpDHc`,
	"invisible": `FamilyHistoryPopup-module__invisible___dgrWi`,
	"col90": `FamilyHistoryPopup-module__col-90___gdJM7`,
	"colAuto": `FamilyHistoryPopup-module__col-auto___nVTtM`,
	"medicalTabs": `FamilyHistoryPopup-module__medical-tabs___Dn71N`,
	"medicalTableNew": `FamilyHistoryPopup-module__medical-table-new___vmSQc`,
	"noPagination": `FamilyHistoryPopup-module__no-pagination___cO1VX`,
	"medicalTableEmpty": `FamilyHistoryPopup-module__medical-table-empty___WgSS7`,
	"iconBtn": `FamilyHistoryPopup-module__icon-btn___WdThb`,
	"searchIcon": `FamilyHistoryPopup-module__search-icon___bK7N4`,
	"disableSelect": `FamilyHistoryPopup-module__disable-select___nOjH1`,
	"breakWord": `FamilyHistoryPopup-module__break-word___X0JJb`,
	"popupClearBtn": `FamilyHistoryPopup-module__popup-clear-btn___qB3Z6`,
	"scrollMB20": `FamilyHistoryPopup-module__scroll-m-b-20___DuztA`,
	"grid": `FamilyHistoryPopup-module__grid___v238h`,
	"width100": `FamilyHistoryPopup-module__width100___ZTTCp`,
	"buttonsContainer": `FamilyHistoryPopup-module__buttonsContainer___W0k48`
};
module.exports = ___CSS_LOADER_EXPORT___;
